import { Product } from 'graphql-api/gql-api-interfaces';

import { RecentProductState } from '../models';

export function getRecentProduct(product: Product): RecentProductState {
  return {
    imageUrl: product.mainImageUrl ?? '',
    id: product.productId,
    articleTitle: product.articleTitle,
    articleId:
      (product?.attributes?.articlenumber as string) ??
      product.displayedProductId ??
      '',
    styleId:
      (product?.attributes?.stylenumber as string) ?? product.parentId ?? '',
  };
}
